export const APP_DENSITY = 0.9;

export const scalePx = (px: number): number => Math.round(px * APP_DENSITY);
